(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('custom-slideshow-component')) {
    class SlideshowComponent extends HTMLElement {
      connectedCallback() {
        // Ensure any inline placeholder SVG stretches and crops like a cover image (cross-browser safety net)
        this.querySelectorAll('svg.slideshow__image').forEach((svg) => {
          svg.setAttribute('preserveAspectRatio', 'xMidYMid slice');
        });

        this.track = this.querySelector('[data-slideshow-track]');
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-slide-dot]'));
        this.prevBtn = this.querySelector('[data-slide-prev]');
        this.nextBtn = this.querySelector('[data-slide-next]');
        this.currentIndex = 0;
        this.autoplay = this.dataset.autoplay === 'true';
        this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed, 10) || 5000;
        this.waitForVideo = this.dataset.waitForVideo === 'true';
        this.timer = null;
        this._videoEndCleanup = null;

        // Belt-and-suspenders for video slides: the URL params (mute=1 /
        // muted=1) already ask YouTube/Vimeo to start muted, but browsers
        // and embed contexts don't always honor that reliably, so force it
        // again via each player's postMessage API once the iframe loads,
        // and do the same for native uploaded videos via the DOM API.
        this.initVideos();

        // Remember the section's default height so per-slide overrides can be restored
        this.defaultMinHeight = this.style.getPropertyValue('--slideshow-min-height');
        this.mobileQuery = window.matchMedia('(max-width: 989px)');
        this._mobileQueryHandler = () => this.applyHeightOverride(this.currentIndex);
        this.mobileQuery.addEventListener('change', this._mobileQueryHandler);
        this.applyHeightOverride(this.currentIndex);

        // Theme editor integration: when the merchant clicks a "Slide" block
        // in the left-hand sidebar, Shopify fires "shopify:block:select".
        // Listen on document (not just this element) since the theme editor
        // can re-render/replace section markup around selection changes, and
        // re-query the slide list live rather than trusting the array
        // captured at connect time. Match via closest() + containment check
        // instead of a strict reference match, since event.target isn't
        // always exactly the [data-slide] element itself.
        this._onBlockSelect = (event) => {
          // Temporary diagnostic: with the theme editor open, check the
          // browser DevTools console (F12) after clicking a slide in the
          // sidebar. If nothing logs here at all, the browser is still
          // running an older cached copy of this file — hard-refresh the
          // editor tab. If it logs "no matching [data-slide] element",
          // the block markup/attribute isn't wired up as expected.
          if (window.Shopify && window.Shopify.designMode) {
            console.log('[slideshow] shopify:block:select fired, target =', event.target, 'detail =', event.detail);
          }
          const slide = event.target.closest && event.target.closest('[data-slide]');
          if (!slide || !this.contains(slide)) {
            if (window.Shopify && window.Shopify.designMode) {
              console.log('[slideshow] no matching [data-slide] element inside this component for that click');
            }
            return;
          }
          const liveSlides = Array.from(this.querySelectorAll('[data-slide]'));
          const index = liveSlides.indexOf(slide);
          if (index > -1) {
            this.slides = liveSlides;
            this._isPaused = true;
            this.stopAutoplay();
            this.goTo(index);
          }
        };
        this._onBlockDeselect = (event) => {
          const slide = event.target.closest && event.target.closest('[data-slide]');
          if (slide && this.contains(slide)) {
            this._isPaused = false;
            this.startAutoplay();
          }
        };
        document.addEventListener('shopify:block:select', this._onBlockSelect);
        document.addEventListener('shopify:block:deselect', this._onBlockDeselect);

        if (this.slides.length <= 1) return;

        if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.goTo(this.currentIndex - 1));
        if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.goTo(this.currentIndex + 1));
        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => this.goTo(parseInt(dot.dataset.slideIndex, 10)));
        });

        this.addEventListener('mouseenter', () => {
          this._isPaused = true;
          this.stopAutoplay();
        });
        this.addEventListener('mouseleave', () => {
          this._isPaused = false;
          this.startAutoplay();
        });
        this.addEventListener('keyup', (event) => {
          if (event.code === 'ArrowLeft') this.goTo(this.currentIndex - 1);
          if (event.code === 'ArrowRight') this.goTo(this.currentIndex + 1);
        });

        this.startAutoplay();
      }

      disconnectedCallback() {
        this.stopAutoplay();
        if (this.mobileQuery && this._mobileQueryHandler) {
          this.mobileQuery.removeEventListener('change', this._mobileQueryHandler);
        }
        if (this._onBlockSelect) {
          document.removeEventListener('shopify:block:select', this._onBlockSelect);
        }
        if (this._onBlockDeselect) {
          document.removeEventListener('shopify:block:deselect', this._onBlockDeselect);
        }
      }

      goTo(index) {
        const total = this.slides.length;
        this.currentIndex = (index + total) % total;
        this.track.style.transform = `translateX(-${this.currentIndex * 100}%)`;

        this.slides.forEach((slide, i) => {
          slide.classList.toggle('is-active', i === this.currentIndex);
        });
        this.dots.forEach((dot, i) => {
          dot.classList.toggle('is-active', i === this.currentIndex);
        });

        this.applyHeightOverride(this.currentIndex);
        this.initVideos();

        // Re-arm the autoplay schedule for whichever slide is now active
        // (fixed timer for images, "wait for the video to finish" for video
        // slides) — unless the mouse is currently hovering the component,
        // in which case autoplay stays paused until mouseleave restarts it.
        if (this.autoplay && !this._isPaused) this.startAutoplay();
      }

      initVideos() {
        // Scoped per-slide (not a flat query over every video on the page):
        // only the currently ACTIVE slide's video should ever be playing.
        // Every slide sits in the DOM at once (just shifted off-screen via
        // transform), so treating them all the same would let an
        // off-screen video autoplay long before the slideshow visually
        // reaches it — which is exactly why videos looked "stuck"/already
        // finished by the time their slide came into view.
        this.querySelectorAll('[data-slide]').forEach((slide) => {
          const isActive = slide.classList.contains('is-active');

          // Native uploaded video
          const video = slide.querySelector('video.slideshow__video');
          if (video) {
            // iOS Safari specifically refuses inline autoplay unless
            // "muted" AND "playsinline" are present as real HTML
            // attributes (not just JS properties) at the moment play() is
            // called, so set both explicitly rather than relying on
            // whatever video_tag happened to output.
            video.setAttribute('muted', '');
            video.setAttribute('playsinline', '');
            video.setAttribute('webkit-playsinline', '');
            video.muted = true;
            video.defaultMuted = true;
            video.volume = 0;

            if (isActive) {
              if (this.waitForVideo) {
                // Don't loop: let it play through once so "ended" actually
                // fires, and always restart from the beginning on revisit
                // (otherwise play() on an already-ended video is a no-op
                // and "ended" never fires again).
                video.loop = false;
                video.currentTime = 0;
              }
              const tryPlay = () => {
                const playPromise = video.play();
                if (playPromise && playPromise.catch) playPromise.catch(() => {});
              };
              tryPlay();
              // iOS can report "loadedmetadata"/"canplay" after the
              // initial attempt; retry once actually ready.
              video.addEventListener('loadedmetadata', tryPlay, { once: true });
              video.addEventListener('canplay', tryPlay, { once: true });
            } else if (this.waitForVideo && !video.paused) {
              video.pause();
            }
          }

          // YouTube/Vimeo embed
          const iframe = slide.querySelector('iframe.slideshow__video-embed[data-src]');
          if (iframe) {
            const baseSrc = iframe.dataset.src;
            if (isActive) {
              if (!iframe.dataset.loaded) {
                // First time this slide has ever been shown: load it now
                // (not before) — the "autoplay=1" already baked into the
                // URL starts playback with no further commands needed.
                iframe.dataset.loaded = 'true';
                iframe.src = baseSrc;
              } else if (this.waitForVideo) {
                // Revisiting later with "wait for video" on: re-assigning
                // src is the reliable way to make it play again — postMessage
                // play/seek commands aren't consistently honored
                // cross-origin (confirmed: the player never posts back any
                // state messages without the full official Player API, so
                // there's nothing to hook into reliably). A cache-busting
                // param forces an actual reload even when the URL is
                // otherwise identical to what's already loaded.
                const separator = baseSrc.indexOf('?') > -1 ? '&' : '?';
                iframe.src = baseSrc + separator + '_play=' + Date.now();
              }
              // else: "wait for video" is off (continuous background loop)
              // and it's already loaded — leave the already-looping iframe
              // alone.
            } else if (iframe.dataset.loaded && this.waitForVideo) {
              // Leaving this slide with "wait for video" on: stop it
              // playing silently off-screen so it's fresh next time.
              iframe.removeAttribute('src');
              iframe.dataset.loaded = '';
            }
          }
        });
      }

      applyHeightOverride(index) {
        const slide = this.slides[index];
        if (!slide) return;
        const override = parseInt(slide.dataset.slideHeight, 10) || 0;
        const isMobileOrTablet = this.mobileQuery ? this.mobileQuery.matches : window.innerWidth <= 989;

        // On mobile/tablet always use the section's normal responsive height
        // so the image is never forced taller than it needs to be (no
        // leftover background gap). The fixed px override only applies on
        // desktop, and even there it's capped to a share of the viewport.
        if (override > 0 && !isMobileOrTablet) {
          this.style.setProperty('--slideshow-min-height', `clamp(280px, 60vh, ${override}px)`);
        } else if (this.defaultMinHeight) {
          this.style.setProperty('--slideshow-min-height', this.defaultMinHeight);
        }
      }

      startAutoplay() {
        if (!this.autoplay || this.slides.length <= 1) return;
        this.stopAutoplay();

        const slide = this.slides[this.currentIndex];
        const video = this.waitForVideo && slide ? slide.querySelector('video.slideshow__video') : null;
        const embed = this.waitForVideo && slide ? slide.querySelector('iframe.slideshow__video-embed') : null;
        const knownDuration = slide ? parseFloat(slide.dataset.videoDuration || '0') : 0;
        const hasKnownDuration = this.waitForVideo && knownDuration > 0 && isFinite(knownDuration);

        if (video) {
          // Prefer the real "ended" event (exact, free, no cross-origin
          // issues for an uploaded video) — advance the moment it actually
          // finishes. Backstop with a timer at the known/entered duration
          // (or a flat cap if that's not available) in case "ended" never
          // fires for some reason.
          const onEnded = () => this.goTo(this.currentIndex + 1);
          video.addEventListener('ended', onEnded, { once: true });
          const fallbackMs = hasKnownDuration
            ? (knownDuration * 1000) + 3000
            : (video.duration && isFinite(video.duration) ? (video.duration * 1000) + 4000 : 60000);
          const fallbackTimer = setTimeout(onEnded, fallbackMs);
          this._videoEndCleanup = () => {
            video.removeEventListener('ended', onEnded);
            clearTimeout(fallbackTimer);
          };
          return;
        }

        if (embed) {
          // YouTube/Vimeo embeds are cross-origin, and testing showed the
          // player never actually posts "ended"/"finish" messages back
          // without the full official Player API handshake — so rather
          // than depend on that, use the merchant-entered "Video length"
          // field as a plain, reliable timer. If no length was entered,
          // fall back to the standard autoplay timing so the slideshow
          // still advances instead of getting stuck.
          const ms = hasKnownDuration ? (knownDuration * 1000) + 500 : this.autoplaySpeed;
          this.timer = setTimeout(() => this.goTo(this.currentIndex + 1), ms);
          return;
        }

        this.timer = setTimeout(() => this.goTo(this.currentIndex + 1), this.autoplaySpeed);
      }

      stopAutoplay() {
        if (this.timer) {
          clearTimeout(this.timer);
          this.timer = null;
        }
        if (this._videoEndCleanup) {
          this._videoEndCleanup();
          this._videoEndCleanup = null;
        }
      }
    }

    customElements.define('custom-slideshow-component', SlideshowComponent);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
